
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 8.702l8.448 8.546c.355.359.93.359 1.286 0a.927.927 0 000-1.3l-9.091-9.196a.904.904 0 00-1.286 0l-9.09 9.195a.922.922 0 00-.267.65c0 .236.089.471.266.65.355.36.931.36 1.286 0L12 8.703z","fill":"currentColor"}})])
          )
        }
      }
    